import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopachmanicab() {



    const cardData = {




keyword: "Mumbai to Panchgani Cab",

headingDescription: "Shreesha Tours & Travels offers reliable, comfortable, and affordable Mumbai to Panchgani cab services for families, couples, tourists, corporate travelers, and weekend vacationers. We provide one-way cabs, round-trip taxi services, hill station tour packages, and customized outstation travel solutions with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every travel requirement and group size. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, easy booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe and comfortable journey to the beautiful hill station of Panchgani. Whether you are planning a family holiday, honeymoon trip, school tour, corporate outing, nature getaway, or weekend escape, our Mumbai to Panchgani cab service provides clean vehicles, professional drivers, and personalized travel assistance. Enjoy the scenic beauty of the Western Ghats while exploring Panchgani's viewpoints, valleys, lakes, caves, and nearby attractions with complete travel convenience.",

topPlaces: [
  {
    title: "Table Land",
    description: "Table Land is the most famous attraction in Panchgani and one of Asia's largest volcanic plateaus. Surrounded by breathtaking mountain views, caves, horse riding activities, and beautiful landscapes, it is a favorite destination for families, couples, photographers, and nature lovers."
  },
  {
    title: "Sydney Point",
    description: "Sydney Point is a popular viewpoint in Panchgani offering spectacular views of Krishna Valley, Dhom Dam, Kamalgad Fort, and surrounding hills. It is an ideal location to enjoy sunrise, sunset, photography, and peaceful moments amidst nature."
  },
  {
    title: "Parsi Point",
    description: "Parsi Point is one of Panchgani's most visited viewpoints, famous for panoramic views of the Krishna Valley and Dhom Dam. The cool breeze, scenic landscapes, and beautiful surroundings make it a perfect stop for travelers exploring Panchgani."
  },
  {
    title: "Devrai Art Village",
    description: "Devrai Art Village is a unique cultural destination showcasing traditional tribal art, handmade crafts, sculptures, and creative workshops. Visitors can experience local craftsmanship and purchase beautiful handmade artworks while enjoying a peaceful environment."
  },
  {
    title: "Rajpuri Caves",
    description: "Rajpuri Caves are ancient caves surrounded by natural beauty and religious significance. Believed to be associated with Lord Kartikeya, these caves attract visitors interested in history, spirituality, and exploring unique natural formations."
  },
  {
    title: "Dhom Dam",
    description: "Dhom Dam near Panchgani is a scenic water reservoir surrounded by hills and greenery. Visitors enjoy boating, photography, and relaxing views of the peaceful landscape, making it a popular destination for families and couples."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden near Panchgani is a famous tourist attraction known for strawberry products, chocolates, fruit-based items, restaurants, and beautiful garden surroundings. It is a must-visit place for families and food lovers traveling in the Mahabaleshwar-Panchgani region."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a famous hill station located near Panchgani, known for viewpoints, strawberry farms, waterfalls, lakes, and temples. Many travelers combine Panchgani and Mahabaleshwar for a complete hill station holiday experience."
  },
  {
    title: "Krishnabai Temple",
    description: "Krishnabai Temple is an ancient temple in Mahabaleshwar dedicated to Goddess Krishnabai and is known for its beautiful architecture and peaceful surroundings. The temple offers stunning views of the Krishna Valley and attracts devotees and tourists."
  },
  {
    title: "Wai",
    description: "Wai is a historic town near Panchgani famous for ancient temples, ghats, scenic landscapes, and traditional Maharashtrian culture. It is also known as a popular Bollywood shooting location and is often included in Panchgani sightseeing tours."
  }
],



"services": [
  {
    "name": "Mumbai to Panchgani Cab",
    "description": "Book Mumbai to Panchgani Cab for safe, comfortable, and reliable hill station travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for family vacations, weekend getaways, sightseeing tours, and peaceful journeys from Mumbai to Panchgani with flexible one way and round trip booking facilities."
  },
  {
    "name": "Mumbai to Panchgani Taxi",
    "description": "Hire Mumbai to Panchgani Taxi service for a smooth and enjoyable journey with experienced drivers, clean vehicles, and affordable travel packages. Our chauffeur-driven taxis provide comfortable transportation for families, couples, corporate groups, and tourists planning a relaxing Panchgani hill station trip."
  },
  {
    "name": "Mumbai to Panchgani Taxi Fare",
    "description": "Check Mumbai to Panchgani Taxi Fare with transparent pricing, affordable packages, and reliable cab services. Get comfortable travel options with professional drivers, well-maintained vehicles, and flexible one way or round trip fares according to your travel requirements."
  },
  {
    "name": "Mumbai to Panchgani Cab Service",
    "description": "Book Mumbai to Panchgani Cab Service with doorstep pickup, professional chauffeurs, clean AC cars, and flexible travel schedules. Enjoy a hassle-free journey for family holidays, sightseeing tours, weekend trips, and personal travel between Mumbai and Panchgani."
  },
  {
    "name": "Mumbai to Panchgani Cab Booking",
    "description": "Complete Mumbai to Panchgani Cab Booking online with quick confirmation, easy reservations, and multiple vehicle choices. Select Sedan, Ertiga, Innova Crysta, SUV, or Tempo Traveller according to passenger count, luggage needs, and trip requirements."
  },
  {
    "name": "Mumbai to Panchgani Car Rental",
    "description": "Choose Mumbai to Panchgani Car Rental for private chauffeur-driven vehicles with comfortable interiors and professional service. Ideal for family vacations, corporate travel, sightseeing, honeymoon trips, and customized Panchgani tour packages from Mumbai."
  },
  {
    "name": "Mumbai to Panchgani One Way Cab",
    "description": "Book Mumbai to Panchgani One Way Cab for economical single-direction travel without return charges. Enjoy fixed pricing, comfortable seating, clean vehicles, and experienced chauffeurs for a convenient and budget-friendly journey."
  },
  {
    "name": "Mumbai to Panchgani Round Trip Taxi",
    "description": "Reserve Mumbai to Panchgani Round Trip Taxi for convenient return travel with flexible schedules and affordable packages. Perfect for weekend holidays, family outings, sightseeing plans, and relaxing hill station tours with comfortable chauffeur-driven cars."
  },
  {
    "name": "Mumbai to Panchgani Outstation Cab",
    "description": "Hire Mumbai to Panchgani Outstation Cab for safe and comfortable long-distance travel with skilled drivers and premium AC vehicles. Enjoy reliable one way and round trip cab services with multiple vehicle options for personal and group journeys."
  },
  {
    "name": "Mumbai Airport to Panchgani Cab",
    "description": "Book Mumbai Airport to Panchgani Cab for timely airport pickup and drop services with professional drivers and comfortable vehicles. Enjoy stress-free airport transfers with Sedan, Ertiga, Innova Crysta, and SUV cab options."
  },
  {
    "name": "Navi Mumbai to Panchgani Taxi",
    "description": "Choose Navi Mumbai to Panchgani Taxi for affordable and reliable travel with experienced chauffeurs and well-maintained vehicles. Get convenient pickup services from Navi Mumbai locations for family trips, tourist journeys, and weekend vacations."
  },
  {
    "name": "Thane to Panchgani Cab",
    "description": "Book Thane to Panchgani Cab with comfortable AC cars, professional drivers, and affordable travel packages. Enjoy a smooth hill station journey from Thane to Panchgani with flexible pickup and customized travel options."
  },
  {
    "name": "Mumbai to Panchgani Tourist Cab",
    "description": "Hire Mumbai to Panchgani Tourist Cab for customized sightseeing trips with experienced drivers and comfortable vehicles. Explore Panchgani attractions with private transportation, flexible schedules, and convenient travel packages."
  },
  {
    "name": "Mumbai to Panchgani Hill Station Taxi",
    "description": "Book Mumbai to Panchgani Hill Station Taxi for a comfortable ride to one of Maharashtra's beautiful hill destinations. Enjoy safe travel with professional chauffeurs, premium vehicles, and flexible booking options."
  },
  {
    "name": "Mumbai to Panchgani Family Trip Cab",
    "description": "Choose Mumbai to Panchgani Family Trip Cab for safe and spacious travel with comfortable vehicles and trained drivers. Perfect for family vacations, sightseeing tours, holiday trips, and memorable hill station journeys."
  },
  {
    "name": "Mumbai to Panchgani Innova Cab",
    "description": "Book Mumbai to Panchgani Innova Cab for spacious family travel with comfortable seating, large luggage space, and experienced chauffeurs. Ideal for group tours, sightseeing trips, and long-distance journeys with premium comfort."
  },
  {
    "name": "Mumbai to Panchgani Innova Crysta Cab",
    "description": "Choose Mumbai to Panchgani Innova Crysta Cab for luxury outstation travel with premium interiors, advanced comfort features, and professional chauffeur service. Perfect for families, executives, and passengers looking for a premium travel experience."
  },
  {
    "name": "Mumbai to Panchgani Ertiga Cab",
    "description": "Reserve Mumbai to Panchgani Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Suitable for families, groups, weekend trips, and convenient hill station transportation."
  },
  {
    "name": "Mumbai to Panchgani Sedan Cab",
    "description": "Book Mumbai to Panchgani Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Ideal for couples, small families, business trips, and smooth highway journeys."
  },
  {
    "name": "Mumbai to Panchgani SUV Cab",
    "description": "Hire Mumbai to Panchgani SUV Cab with spacious seating, premium comfort, and extra luggage capacity. Perfect for families, groups, and passengers who prefer a comfortable and relaxed journey."
  },
  {
    "name": "Mumbai to Panchgani Tempo Traveller",
    "description": "Book Mumbai to Panchgani Tempo Traveller for group travel with spacious seating, comfortable interiors, and professional drivers. Ideal for large families, corporate outings, friends groups, and sightseeing tours."
  },
  {
    "name": "Best Mumbai to Panchgani Cab Booking",
    "description": "Choose Best Mumbai to Panchgani Cab Booking service with experienced drivers, quality vehicles, affordable fares, and reliable customer support. Enjoy safe, comfortable, and convenient transportation solutions for Panchgani holidays, family tours, and weekend getaways."
  }
],
"tableData": [
  ["Mumbai to Panchgani Cab", "Mumbai to Panchgani Taxi"],
  ["Mumbai to Panchgani Taxi Fare", "Mumbai to Panchgani Cab Service"],
  ["Mumbai to Panchgani Cab Booking", "Mumbai to Panchgani Car Rental"],
  ["Mumbai to Panchgani One Way Cab", "Mumbai to Panchgani Round Trip Taxi"],
  ["Mumbai to Panchgani Outstation Cab", "Mumbai Airport to Panchgani Cab"],
  ["Navi Mumbai to Panchgani Taxi", "Thane to Panchgani Cab"],
  ["Mumbai to Panchgani Tourist Cab", "Mumbai to Panchgani Hill Station Taxi"],
  ["Mumbai to Panchgani Family Trip Cab", "Mumbai to Panchgani Innova Cab"],
  ["Mumbai to Panchgani Innova Crysta Cab", "Mumbai to Panchgani Ertiga Cab"],
  ["Mumbai to Panchgani Sedan Cab", "Mumbai to Panchgani SUV Cab"],
  ["Mumbai to Panchgani Tempo Traveller", "Best Mumbai to Panchgani Cab Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Panchgani Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers a convenient Mumbai to Panchgani cab service for travellers looking for a peaceful hill station journey with reliable vehicles, experienced drivers, and flexible travel arrangements."
  },
  {
    WhyChooseheading: "Perfect Cab Option for Hill Station Holidays",
    WhyChoosedescription: "Travel comfortably from Mumbai to Panchgani for family vacations, weekend breaks, couple trips, and sightseeing tours with a private taxi at your convenience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices for Your Trip",
    WhyChoosedescription: "Select from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options according to your group size and comfort requirements."
  },
  {
    WhyChooseheading: "Scenic Route Travel with Experienced Drivers",
    WhyChoosedescription: "Our chauffeurs have good knowledge of highway and hill routes, ensuring a safe and comfortable drive while travelling towards Panchgani."
  },
  {
    WhyChooseheading: "Suitable for Families, Couples & Groups",
    WhyChoosedescription: "Whether you are planning a family holiday, romantic getaway, friends trip, or corporate outing, our spacious cabs provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "Customize Your Panchgani Sightseeing Plan",
    WhyChoosedescription: "Explore popular attractions like Table Land, Sydney Point, Parsi Point, Mapro Garden, Wai, and nearby sightseeing places with a customized cab itinerary."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Choose a one-way taxi, return cab, or multi-day travel package based on your schedule and holiday requirements."
  },
  {
    WhyChooseheading: "Hassle-Free Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Get quick assistance, clear pricing, and dependable support while arranging your Mumbai to Panchgani taxi booking."
  }
]

};

const faqData = [
  {
    question: "Why is a private cab a good option for Mumbai to Panchgani travel?",
    answer: "A private cab provides direct transportation, comfortable seating, flexible stops, and a convenient travel experience for hill station trips."
  },
  {
    question: "Can I hire Mumbai to Panchgani taxi for a family vacation?",
    answer: "Yes, our cabs are suitable for families, couples, friends groups, and travellers planning a Panchgani holiday."
  },
  {
    question: "Which vehicles can I choose for Mumbai to Panchgani Cab?",
    answer: "You can select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller depending on your requirements."
  },
  {
    question: "Can I include sightseeing places during my Panchgani trip?",
    answer: "Yes, sightseeing stops like Table Land, Sydney Point, Parsi Point, Mapro Garden, Wai, and nearby attractions can be added."
  },
  {
    question: "Is one-way Mumbai to Panchgani cab service available?",
    answer: "Yes, one-way cab services are available for passengers who need direct travel from Mumbai to Panchgani."
  },
  {
    question: "Can I book a return taxi from Panchgani to Mumbai?",
    answer: "Yes, return journey and round-trip cab options are available according to your preferred timing."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, hotels, railway stations, offices, homes, and other preferred locations."
  },
  {
    question: "Is the cab comfortable for senior citizens travelling to Panchgani?",
    answer: "Yes, comfortable vehicles and experienced drivers make the journey suitable for senior citizens and family travellers."
  },
  {
    question: "Are toll charges and parking fees included in the cab fare?",
    answer: "Toll, parking, permits, and additional charges depend on the selected package and are explained before booking confirmation."
  },
  {
    question: "How can I book Mumbai to Panchgani Cab Service?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive cab availability and booking information."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Joshi",
    feedback: "The Mumbai to Panchgani cab service by Shreesha Tours & Travels was excellent. The driver handled the hill roads professionally, and the vehicle was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Patil",
    feedback: "We enjoyed our Panchgani family trip in an Innova Crysta. The cab was clean, the journey was smooth, and the overall service experience was very good.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Panchgani Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-panchgani-cab.webp",
  "description":
    "Book Mumbai to Panchgani Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Panchgani with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for hill station vacations, family trips, sightseeing tours, weekend getaways, and business travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-panchgani-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Panchgani Cab | Hill Retreat Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Panchgani Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Panchgani with 24x7 online cab booking and experienced drivers."
  />

  <meta
    name="keywords"
    content="Mumbai to Panchgani Cab, Mumbai to Panchgani Taxi, Mumbai to Panchgani Taxi Fare, Mumbai to Panchgani Cab Service, Mumbai to Panchgani Cab Booking, Mumbai to Panchgani Car Rental, Mumbai to Panchgani One Way Cab, Mumbai to Panchgani Round Trip Taxi, Mumbai to Panchgani Outstation Cab, Mumbai to Panchgani Taxi Booking, Mumbai to Panchgani Innova Cab, Mumbai to Panchgani Sedan Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopachmanicab;